import {
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { LinkButton } from "@/components/shared/generic";

const FreeCreditsModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading as="h2" size="lg">
            Claimed
          </Heading>
        </ModalHeader>
        <ModalBody>
          <Text fontSize="lg">You&apos;ve successfully claimed your free credits. Enjoy!</Text>
        </ModalBody>
        <ModalFooter>
          <LinkButton colorScheme="green" href="/profiles?advanced=true&eligible_for_free=true">
            Browse Profiles
          </LinkButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FreeCreditsModal;
